export * from './miniProgram'
